<template>
  <div v-loading="loading">
    <template v-if="showType == DEALGROUP_SHOW_BTN">
      <div class="inline-block btn-wrapper" v-for="deal in deals">
        <el-button
          type="self"
          :style="{
            backgroundColor: deal.btn_color,  
            color: deal.font_color 
          }"
          @click="dealBtnEvent(deal.dealInfo, row, {})"
          v-if="!noRender(deal.dealInfo) && deal.btn_color">
          {{ deal.dealInfo.name }}
        </el-button>
        <el-button
          type="primary"
          @click="dealBtnEvent(deal.dealInfo, row, {})"
          v-if="!noRender(deal.dealInfo) && !deal.btn_color">
          {{ deal.dealInfo.name }}
        </el-button>
      </div>
    </template>
    <template v-if="showType == DEALGROUP_SHOW_TABLE">
      <el-table
        class="table-center"
        :data="deals"
        style="width: 100%">
        <el-table-column
          :label="name">
          <template scope="scope">
            <div class="tx-c">
              <el-button 
                type="text" 
                @click="dealBtnEvent(scope.row.dealInfo, row, {})">
                {{ scope.row.dealInfo.name }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <edit-deal ref="editDeal" :source="editSource" @editCallback="editCallback"></edit-deal>
    <delete-deal ref="deleteDeal" :source="deleteSource" @deleteCallback="deleteCallback"></delete-deal>
    <status-deal ref="statusDeal" :source="statusSource" @statusCallback="statusCallback"></status-deal>
    <email-deal ref="emailDeal" :source="emailSource" @emailCallback="emailCallback"></email-deal>
  </div>
</template>

<style scope>
</style>

<script>
  import http from '../../../assets/js/http'
  import cmsConfig from '../../../config/cmsConfig'
  import dealMethod from './mixins/dealMethod'  // 执行各操作的方法集合
  import editDeal from './deal/editDeal'
  import deleteDeal from './deal/deleteDeal'
  import statusDeal from './deal/statusDeal'
  import emailDeal from './deal/emailDeal'
  export default {
    props: {
      contentId: {
        type: Number,
        default() {
          return 0
        }
      },
      dealId: {
        type: Number,
        default() {
          return 0
        }
      },
      dataId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        showType: 0,
        deals: [],
        row: null,
        name: '操作',
        loading: false
      }
    },
    async created() {
      this.getDeals()
      if (this.dataId) {
        this.row = {
          id: this.dataId
        }
      }
    },
    methods: {
      async getDeals() {
        this.loading = true
        let res = await this.apiGet(`cms/contents/${this.contentId}/function_list/${this.dealId}`)
        let data = this.promiseHandler(data, res)
        this.deals = data.deals
        this.showType = data.btn_show_type
        if (data.name) {
          this.name = data.name
        }
        this.loading = false
      },
      noRender(deal) {
        return deal.type == this.OPERATION_SELF ||
               deal.type == this.OPERATION_IMPORT ||
               deal.type == this.OPERATION_FILTER
      },
      editCallback(isSuccess, res) {  // 编辑数据回调函数
        if (isSuccess) {
          setTimeout(() => {
            _g.reloadPage(this)
          }, 1000)
        }
      },
      deleteCallback(isSuccess, res) { // 删除数据回调函数
        if (isSuccess) {
          _g.toastMsg(this, 'success', '删除成功！')
          setTimeout(() => {
            _g.reloadPage(this)
          }, 1000)
        }
      },
      statusCallback(isSuccess, res) { // 改变数据状态回调函数
        if (isSuccess) {
          _g.toastMsg(this, 'success', '操作成功！')
          setTimeout(() => {
            _g.reloadPage(this)
          }, 1000)
        }
      },
      emailCallback(isSuccess) {  // 发送邮件回调
        if (isSuccess) {
          _g.toastMsg(this, 'success', '发送成功！')
        }
      }
    },
    watch: {
      'dataId'() {
        if (this.dataId) {
          this.row = {
            id: this.dataId
          }
        } else {
          this.row = null
        }
      }
    },
    components: {
      editDeal,
      deleteDeal,
      statusDeal,
      emailDeal
    },
    mixins: [http, cmsConfig, dealMethod]
  }
</script>


// WEBPACK FOOTER //
// dealGroupRender.vue?9a77bfc2